import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
import { ModalReducer } from "./modal/reducer";
import { TabReducer } from "./tab/reducer";
import { getHistory } from "./history/reduces";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  modal: ModalReducer,
  reducerTab: TabReducer,
  history: getHistory,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
